import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class extends Controller {
  static values = {
    pattern: String
  }

  connect() {
    console.log("mask connect")
    if (this.hasPatternValue) {
      const mask = IMask(this.element, { mask: this.patternValue, lazy: false })
      mask.on("accept", () => {
        if (mask.masked.isComplete) {
          this.element.dispatchEvent(new Event("validate"))
        }
      })
    } else {
      console.warn(`Brak atrybutu data-mask-pattern dla inputu:`, this.element)
    }
  }
}
